export default function codeComponent() {
  return {};
}
